
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

export const settingsAccessWhitelistConfig = {
    all:  {
        title: "whitelists",
        icon: <Inventory2OutlinedIcon/>,
        isSingleDataGrid: true,
    },
};
